export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-key-49d57da5bd4598f897e0aee7147b24b4.svg";